/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Typography,
  Grid,
  IconButton,
} from '@material-ui/core';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { Loading, exportXlsx } from '../../helpers/utils';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import ScaleOralParticipation from './ExamType0Grades/ScaleOralParticipation';
import ScaleOralPresential from './ExamType0Grades/ScaleOralPresential';
import ScaleQuizOnPaper60Min from './ExamType0Grades/ScaleQuizOnPaper60Min';
import ScaleQuizOnPaper90Min from './ExamType0Grades/ScaleQuizOnPaper90Min';
import ScaleExamSemester4 from './ExamType0Grades/ScaleExamSemester4';
import ScaleExamSemester5 from './ExamType0Grades/ScaleExamSemester5';
import ScaleExamSemester6 from './ExamType0Grades/ScaleExamSemester6';
import ScaleOralPosterPresentation from './ExamType0Grades/ScaleOralPosterPresentation';
import ScaleOralCaseStudy from './ExamType0Grades/ScaleOralCaseStudy';
import ScaleOralRolePlay from './ExamType0Grades/ScaleOralRolePlay';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResults = ({ examIdentifier }) => {
  const [loadingState, setLoadingState] = useState(true);
  const [substring, setSubstring] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [totalPapers, setTotalPapers] = useState(0);
  const [exam, setExam] = useState({});
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Corrector',
      field: 'teacherId', // Peut rester vide si nous utilisons uniquement render()
      render: (rowData) => {
        if (rowData.teacherId && rowData.teacherId.firstname) {
          return <Typography variant="caption">{`${rowData.teacherId.firstname} ${rowData.teacherId.name}`}</Typography>;
        }
        return <Typography variant="caption">No corrector assigned</Typography>;
      },
    },
    {
      title: 'Name',
      field: 'name',
      hidden: !!exam.anonymous,
      defaultSort: 'asc',
    },
    {
      title: 'Firstname',
      field: 'firstname',
      hidden: !!exam.anonymous,
    },
    {
      title: 'Number',
      field: 'number',
      hidden: !exam.anonymous,
    },
    {
      title: 'Grade',
      field: 'results.grade',
      width: '40%',
      render: (rowData) => {
        if (exam.modality === 'Oral Participation') {
          return <ScaleOralParticipation rowData={rowData} />;
        }
        if (exam.modality === 'Oral - cours en présentiel') {
          return <ScaleOralPresential rowData={rowData} />;
        }
        if (exam.modality === 'Oral : Role Play') {
          return <ScaleOralRolePlay rowData={rowData} />;
        }
        if (exam.modality === 'Oral : Case study') {
          return <ScaleOralCaseStudy rowData={rowData} />;
        }
        if (exam.modality === 'Oral : Poster Presentation') {
          return <ScaleOralPosterPresentation rowData={rowData} />;
        }
        if ((exam.semester === 3 || exam.semester === 1)
          && (exam.duration === 60 || exam.durations === 60 || exam.duration === '1h' || exam.duration === '1h ')
          && rowData.grade !== 'No grade'
          && rowData.grade !== undefined
          && rowData.grade !== null) {
          return <ScaleQuizOnPaper60Min rowData={rowData} />;
        }
        if ((exam.semester === 3 || exam.semester === 1)
          && (exam.duration === 90 || exam.durations === 90 || exam.duration === '1h30' || exam.duration === '1h 30min')
          && rowData.grade !== 'No grade'
          && rowData.grade !== undefined
          && rowData.grade !== null) {
          return <ScaleQuizOnPaper90Min rowData={rowData} />;
        }
        if ((exam.semester === 4 || exam.semester === 2) && rowData.grade !== 'No grade' && rowData.grade !== undefined && rowData.grade !== null) {
          return <ScaleExamSemester4 rowData={rowData} />;
        }
        if (exam.semester === 5 && rowData.grade !== 'No grade' && rowData.grade !== undefined && rowData.grade !== null) {
          return <ScaleExamSemester5 rowData={rowData} />;
        }
        if (exam.semester === 6 && rowData.grade !== 'No grade' && rowData.grade !== undefined && rowData.grade !== null) {
          return <ScaleExamSemester6 rowData={rowData} />;
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No grade</Typography>;
      },
    },
    {
      title: 'Comment',
      field: 'results.comment',
      render: (rowData) => {
        if (rowData.comment !== 'No comment') {
          return (
            <Typography style={{ color: '#757575', fontSize: '13px' }}>
              {rowData.comment}
            </Typography>
          );
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No comment</Typography>;
      },
    },
  ];

  const loadExamResults = async () => {
    setLoadingState(true);
    const examRes = await elearningDetailsServices.getElearningDetailWithStudents(examIdentifier);
    if (examRes) {
      setExam(examRes.exam);
      if (examRes.exam.anonymous) {
        const formatedArray = [];
        let papers = 0;
        examRes.exam.results?.forEach((result) => {
          if (result.number) {
            formatedArray.push({
              teacherId: result.teacherId || 'No corrector assigned',
              number: result.number || '',
              grade: result.grade || 'No grade',
              comment: result.comment || 'No comment',
            });
            if (result.grade) {
              const grades = Object.values(result.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
          }
        });
        setTotalPapers(papers);
        setExamData(formatedArray);
        setLoadingState(false);
      } else {
        const formatedArray = [];
        const examStudents = [];
        if (examRes.students) {
          examRes.students.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(examRes.exam.semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(examRes.exam.semester, 10)
              || student.catchUp?.includes(parseFloat(examRes.exam.semester, 10))) {
              examStudents.push(student);
            }
          });
          let papers = 0;
          examStudents.forEach((student) => {
            const studentObj = {
              teacherId: student.teacherId || 'No corrector assigned',
              userId: student._id,
              name: student.name,
              firstname: student.firstname,
              grade: 'No grade',
              comment: 'No comment',
            };
            if (examRes.exam.results !== undefined && examRes.exam.results.length > 0) {
              examRes.exam.results.forEach((result) => {
                if (result?.userId === student._id) {
                  studentObj.teacherId = result.teacherId || 'No corrector assigned';
                  studentObj.grade = result.grade;
                  studentObj.comment = result.comment || '/';
                }
              });
            }
            if (studentObj.grade && studentObj.grade !== 'No grade') {
              const grades = Object.values(studentObj.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
            formatedArray.push(studentObj);
          });
          setTotalPapers(papers);
          setExamData(formatedArray);
          setLoadingState(false);
        }
      }
    }
  };

  useEffect(() => {
    loadExamResults();
  }, []);

  const handleRedirect = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            loadingState === false
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${exam?.name ? exam.name.replace(/\b(level 1|level 2)\b\s*$/i, '') : ''} - Total papers: ${totalPapers || 0}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: examData.length > 0 ? '' : 'No results to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam } || null;
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name - b.name);
                      resultsArr.forEach((elem) => {
                        const item = { ...elem };
                        if (exam.anonymous) {
                          item['Numéro'] = item.number;
                        } else {
                          item.Nom = item.name;
                          item['Prénom'] = item.firstname;
                        }
                        if (item.grade !== 'No grade' && item.grade !== undefined) {
                          if (examObj.modality === 'Oral Participation') {
                            item['Présence et implication (/10)'] = item.grade.participation;
                            item['Prise de parole spontanée (/5)'] = item.grade.spontaneousSpeaking;
                            item['Prise de parole sollicitée (/5)'] = item.grade.speechRequested;
                            item['Note (/20)'] = parseFloat(item.grade.participation, 10) + parseFloat(item.grade.speechRequested, 10) + parseFloat(item.grade.spontaneousSpeaking, 10);
                          } else if (examObj.modality === 'Oral - cours en présentiel') {
                            item['Structure de la présentation (/5)'] = item.grade.structure;
                            item['Vocabulaire médical (/5)'] = item.grade.vocabulary;
                            item['Syntaxe et Grammaire (/5)'] = item.grade.syntax;
                            item['Contenu, qualité de la présentation (/5)'] = item.grade.content;
                            item['Total (/20)'] = parseFloat(item.grade.structure, 10) + parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.syntax, 10) + parseFloat(item.grade.content, 10);
                          } else if (examObj.modality === 'Oral : Role Play') {
                            item['Compréhension du contexte (/5)'] = item.grade.contextComprehension;
                            item['Maîtrise de la langue  (/5)'] = item.grade.languageMastery;
                            item['Vocabulaire (/10)'] = item.grade.vocabulary;
                            item['Note (/20)'] = parseFloat(item.grade.contextComprehension, 10) + parseFloat(item.grade.languageMastery, 10) + parseFloat(item.grade.vocabulary, 10);
                          } else if (examObj.modality === 'Oral : Case study') {
                            item['Compréhension du contexte (/5)'] = item.grade.contextComprehension;
                            item['Syntaxe et grammaire (/5)'] = item.grade.languageMastery;
                            item['Vocabulaire médical (/5)'] = item.grade.vocabulary;
                            item['Qualité de la présentation (/5)'] = item.grade.implication;
                            item['Note (/20)'] = parseFloat(item.grade.contextComprehension, 10) + parseFloat(item.grade.languageMastery, 10) + parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.implication, 10);
                          } else if (examObj.modality === 'Oral : Poster Presentation') {
                            item['Qualité du poster (clarté du contenu, agencement) (/2.5)'] = item.grade.posterQuality;
                            item['Qualité de la présentation (pertinence, structure) (/2.5)'] = item.grade.presentationQuality;
                            item['Grammaire et syntaxe (/5)'] = item.grade.languageMastery;
                            item['Vocabulaire médical (/10)'] = item.grade.vocabulary;
                            item['Note (/20)'] = parseFloat(item.grade.posterQuality, 10) + parseFloat(item.grade.presentationQuality, 10) + parseFloat(item.grade.languageMastery, 10) + parseFloat(item.grade.vocabulary, 10);
                          } else if ((examObj.semester === 4 || examObj.semester === 2) && (examObj.examModality === undefined || examObj.examModality === 'Sur table')) {
                            item['Vocabulaire et termes médicaux (/10)'] = item.grade.vocabulary;
                            item['Compréhension globale (/5)'] = item.grade.globalcomprehension;
                            item['Syntaxe (/5)'] = item.grade.syntax;
                            item['Note (/20)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.globalcomprehension, 10) + parseFloat(item.grade.syntax, 10);
                          } else if (examObj.semester === 5) {
                            item['Vocabulaire et termes médicaux (/10)'] = item.grade.vocabulary;
                            item['Structure (/3)'] = item.grade.structure;
                            item['Contenu, qualité et idées globales (/5)'] = item.grade.content;
                            item['Syntaxe (/2)'] = item.grade.syntax;
                            item['Note (/20)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.structure, 10) + parseFloat(item.grade.content, 10) + parseFloat(item.grade.syntax, 10);
                          } else if (examObj.semester === 6) {
                            item['Vocabulaire et termes médicaux (/10)'] = item.grade.vocabulary;
                            item['Méthodologie (/5)'] = item.grade.methodology;
                            item['Mots clé (/2.5)'] = item.grade.keywords;
                            item['Syntaxe (/2.5)'] = item.grade.syntax;
                            item['Note (/20)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.methodology, 10) + parseFloat(item.grade.keywords, 10) + parseFloat(item.grade.syntax, 10);
                          } else if (examObj.semester === 3 && (examObj.durations === 60 || examObj.duration === '1h ' || examObj.duration === 60)) {
                            item['Vocabulaire et termes médicaux (/60)'] = item.grade.vocabulary;
                            item['Compréhension écrite (/20)'] = item.grade.readingcomprehension;
                            item['Score (/80)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10);
                            item['Note (/20)'] = Math.round(((parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10)) / 80) * 20);
                          } else if (examObj.semester === 3 && (examObj.durations === 90 || examObj.duration === '1h 30min' || examObj.duration === 90)) {
                            item['Vocabulaire et termes médicaux (/80)'] = item.grade.vocabulary;
                            item['Compréhension écrite (/20)'] = item.grade.readingcomprehension;
                            item['Score (/100)'] = parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10);
                            item['Note (/20)'] = Math.round(((parseFloat(item.grade.vocabulary, 10) + parseFloat(item.grade.readingcomprehension, 10)) / 100) * 20);
                          }
                        }
                        if (item.grade === undefined) {
                          item.grade = 'n/a';
                        }
                        if (exam && exam !== null) {
                          exam.results.forEach((result) => {
                            if (result.userId === item.userId) {
                              item.Commentaire = result.comment;
                            }
                          });
                        }
                        delete item.tableData;
                        delete item.comment;
                        delete item.grade;
                        delete item.name;
                        delete item.firstname;
                        delete item.userId;
                        delete item.file;
                        delete item.created_at;
                        delete item.groupId;
                        delete item.answer;
                        delete item.fetched;
                        delete item.state;
                        delete item.testId;
                        delete item.total;
                        delete item.groupId;
                        delete item.note;
                        delete item.number;
                        delete item.teacherId;
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${examObj.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
        </Grid>
      </Grid>
    </div>
  );
};

ExamResults.propTypes = {
  examIdentifier: PropTypes.string.isRequired,
};

export default ExamResults;
